import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { SNACK_TIMEOUT } from '@app/shared';
import { ErrorService } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  constructor(
    private readonly snackBar: MatSnackBar
  ) { }

  showSuccess(
    message: string, 
    actionText: string = '', 
    config: MatSnackBarConfig<any> = { duration: SNACK_TIMEOUT }
  ): MatSnackBarRef<any> {
    return this.snackBar.open(message, actionText, config);
  }
   
  showError(errorResponse: HttpErrorResponse, actionText: string = '') {
    let errorMessage = new ErrorService(errorResponse).handleError();
    return this.snackBar.open(errorMessage, actionText, { duration: SNACK_TIMEOUT }).onAction();
  }

  showMessage(
    message: string, 
    actionText: string = '', 
    config: MatSnackBarConfig<any> = { duration: SNACK_TIMEOUT }
  ): MatSnackBarRef<any> {
    return this.snackBar.open(message, actionText, config);
  }

  closeSnackbar() {
    this.snackBar.dismiss();
  }

}